export default [
    {
        name: 'cadastro-cidadao',
        path: 'cidadao',
        redirect: 'cidadao/index',
        component: () => import(/* webpackChunkName: 'cadastro-cidadao' */ '@/views/cadastro/cidadao/Index'),
        children: [
            {
                meta: { title: 'Lista de cidadãos' },
                name: 'cadastro-cidadao-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-cidadao' */ '@/views/cadastro/cidadao/List.vue'),
            },
            {
                meta: { title: 'Cadastro de cidadão' },
                name: 'cadastro-cidadao-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-cidadao' */ '@/views/cadastro/cidadao/Form.vue'),
            },
            {
                meta: { title: 'Edição de cidadão' },
                name: 'cadastro-cidadao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'cadastro-cidadao' */ '@/views/cadastro/cidadao/Form.vue'),
            },
        ],
    },
]